import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';

/**
 * Резолвер списка оборудования, чтобы подгрузить данные до того как примаунтится компонент, которому эти данные нужны
 */

@Injectable()
export class ApparatusCardResolverService extends BaseResolverService {
    constructor(
        service: CardApiService,
        router: Router
    ) {
        super(service, router);
    }
}
